import React from 'react';
import './Hero.css';
import heroImage from '../img/top2.jpg';

const Hero = () => {
  const scrollToCTA = () => {
    const ctaSection = document.getElementById('cta');
    if (ctaSection) {
      ctaSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero">
      <div className="hero__background">
        <div className="hero__background-overlay"></div>
        <img src={heroImage} alt="経営者の孤独" className="hero__background-image" />
      </div>

      {/* 境界線の装飾要素 */}
      <div className="hero__divider">
      </div>

      {/* 左側の装飾的な円形要素 */}
      <div className="hero__decoration">
        <div className="hero__circle hero__circle--large"></div>
        <div className="hero__circle hero__circle--medium"></div>
        <div className="hero__circle hero__circle--small"></div>
      </div>

      <div className="container hero__container">
        <div className="hero__content fade-in-up">
          <h1 className="hero__title">
            1人で<br />営業・採用・現場対応<br />
            を抱える経営から、<br />
            <span className="hero__title-highlight">脱却</span>しませんか?
          </h1>

          <button className="hero__cta-button" onClick={scrollToCTA}>
            無料で相談する →
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
